const typeOfContract = {
  Full_Time: "64670fbe6cb18be88f7cc3bc",
  Part_Time: "646714b36cb18be88f7cc3c2",
  Hourly_Rate: "6467154beb8ffe1659e9cd55",
};
export default typeOfContract;

